import React, { Component, Fragment } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Page from 'src/components/page'
import Hrule from 'src/components/hrule'
import { getWindow } from 'src/utils'
import PillButton from 'src/components/pill-button'
import { dispatch } from 'src/store'
import { MOBILE_BREAK, SCROLL_TO_USE_CASES_DURATION } from 'src/utils/consts'
import { setCurrentUseCase, setShouldShowUseCases } from 'src/actions'
import homeHero from 'src/assets/home-hero.png'
import Image from 'src/components/image'
import DesktopUseCases from 'src/components/desktop-use-cases'
import MobileUseCases from 'src/components/mobile-use-cases'
import scrollToElement from 'scroll-to-element'

export const title = ''
export const description = ''

export class HomePage extends Component {
  static propTypes = {
    useCases: PropTypes.array.isRequired,
    shouldShowUseCases: PropTypes.bool.isRequired,
    currentUseCase: PropTypes.object,
    windowWidth: PropTypes.number.isRequired,
    windowHeight: PropTypes.number.isRequired,
  }

  static defaultProps = {
    currentUseCase: null,
  }

  scroll = () => {
    const { windowWidth, windowHeight } = this.props
    if (!getWindow() || windowWidth <= MOBILE_BREAK) return
    const element = document.querySelector('.use-case-buttons')
    const offset = -(windowHeight * 0.5 - element.offsetHeight * 0.5)
    const duration = SCROLL_TO_USE_CASES_DURATION
    scrollToElement(element, {
      offset: offset,
      duration: duration,
    })
  }

  render() {
    const { scroll } = this
    const { useCases, currentUseCase, shouldShowUseCases, windowWidth } = this.props
    return (
      <Fragment>
        <Page
          pageClassName="home"
          pageContentClassName="im-home-page"
          title={title}
          description={description}>
          <section className="intro">
            <section className="copy">
              <h4>TRUELINK</h4>
              <h1>Own and optimize your customer experience</h1>
              <p>TrueLink™ intelligently routes each customer where you want them to go</p>
            </section>
            <section className="hero">
              <Image src={homeHero} className="home-hero" alt="Home Hero Image" cover={false} />
            </section>
          </section>
          <Hrule />
          <section className="use-case-buttons">
            <section className="copy-and-buttons">
              <section className="copy">
                <h2>
                  {windowWidth > 1024
                    ? `
                    With TrueLink, you can dynamically reroute users anywhere you want them to go — without even
                    asking your partners to swap out links.
                    `
                    : `
                    Dynamically reroute users anywhere, anytime.
                    `}
                </h2>
              </section>
              <section className="buttons">
                {useCases.map(useCase => (
                  <PillButton
                    key={useCase.buttonLabel}
                    onClick={() => {
                      dispatch(setCurrentUseCase(useCase))
                      dispatch(setShouldShowUseCases(true))
                      scroll()
                    }}
                    className={c(
                      'use-case-button',
                      shouldShowUseCases && currentUseCase && currentUseCase.id === useCase.id && 'selected'
                    )}>
                    {useCase.buttonLabel}
                  </PillButton>
                ))}
              </section>
            </section>
            <DesktopUseCases />
          </section>
          <Hrule />
        </Page>
        <MobileUseCases />
      </Fragment>
    )
  }
}

export default connect(state => ({
  useCases: state.useCases,
  currentUseCase: state.currentUseCase,
  shouldShowUseCases: state.shouldShowUseCases,
  windowWidth: state.windowWidth,
  windowHeight: state.windowHeight,
}))(HomePage)
